import {
  list,
  listItems,
  payment,
  checkCharge,
  acceptQuoteItems,
} from './quoteService'

const state = {
  quotes: null,
  quoteItems: null,
  quoteItemsList: [],
  quotePaymentType: null,
  quotePricesAndDiscounts: {},
  isQuotePaymentLoading: false,
  quoteWasNotFound: false,
  quotePaymentStatus: null,
  showQuoteMessageSuccess: true,
  isQuotePaid: false,
  isQuoteClear: false,
}

const getters = {
  quotes: (state) => state.quotes,
  quoteItems: (state) => state.quoteItems,
  quoteItemsList: (state) => state.quoteItemsList,
  quotePaymentType: (state) => state.quotePaymentType,
  isQuotePaymentLoading: (state) => state.isQuotePaymentLoading,
  quoteWasNotFound: (state) => state.quoteWasNotFound,
  quotePaymentStatus: (state) => state.quotePaymentStatus,
  showQuoteMessageSuccess: (state) => state.showQuoteMessageSuccess,
  payWithFci: (state) => state.quoteItems ? state.quoteItems.total == 0 : false,
  isQuotePaid: (state) => state.isQuotePaid,
  isQuoteClear: (state) => state.isQuoteClear,
}

const actions = {
  async fetchQuotes({ commit, dispatch }, serviceReportId) {
    commit('setIsLoading', true)
    commit('setQuoteWasNotFound', false)

    try {
      const { data } = await list(serviceReportId)
      if (!data || data.length <= 0) {
        commit('setQuoteWasNotFound', true)
        return
      }

      commit('setQuotes', data[0])
      dispatch('fetchQuoteItems', data[0]?.id)
    } catch (response) {
      commit('setIsLoading', false)

      if (
        response?.status == 400 ||
        response?.status == 404 ||
        response.status == 500
      ) {
        commit('setQuoteWasNotFound', true)
        return
      }

      response?.data?.errors && response?.data?.errors?.length >= 1
        ? dispatch('showErrorMessage', response.data.errors[0].message)
        : dispatch('showErrorMessage', response.data.message)
    }
  },

  async fetchQuoteItems({ commit, dispatch }, quoteId) {
    try {
      const { data } = await listItems(quoteId)
      commit('setQuoteItems', data)
      commit('setQuoteItemsList', data?.items)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async doQuotePayment({ commit, dispatch }, paymentData) {
    commit('setIsQuoteClear', false)
    commit('setIsQuotePaymentLoading', true)

    const serviceReportId = window?.location?.pathname.replace('/quote/', '')

    try {
      const response = await payment(paymentData)
      response.status === 200 && commit('setSuccessData', response?.data)

      const installments = response?.data?.installments

      if (installments?.length) {
        if (
          installments[0]?.status === 'CONFIRMED' ||
          installments[0]?.status === 'RECEIVED'
        ) commit('setIsQuotePaid', true)
      }

      dispatch('fetchQuotes', serviceReportId)
    } catch ({ data }) {
      commit('setIsQuoteClear', true)
      commit('setSuccessData', null)
      dispatch('fetchQuotes', serviceReportId)
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsQuotePaymentLoading', false)
    }
  },

  async refreshPixQuote({ commit, dispatch }, installmentId) {
    if (state.isQuotePaid) return
    if (state.isQuoteClear) return

    try {
      const { data } = await checkCharge(installmentId)
      const { status } = data?.installments[0]
      commit('setQuotePaymentStatus', status)
      return state.quotePaymentType
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  acceptQuoteItems({ commit, dispatch }, body) {
    commit('setIsLoading', true)

    acceptQuoteItems(body)
      .then(() => dispatch('fetchServiceReport', body.appointment_id))
      .catch(({ data }) => {
        data?.errors && data?.errors?.length >= 1
          ? dispatch('showErrorMessage', data.errors[0].message)
          : dispatch('showErrorMessage', data.message)
      })
      .finally(() => commit('setIsLoading', false))
  },
}

const mutations = {
  setQuotes: (state, quotes) => {
    state.quotes = quotes
  },

  setQuoteItems: (state, items) => {
    state.quoteItems = items
  },

  setQuoteItemsList: (state, list) => {
    state.quoteItemsList = list
  },

  setQuotePaymentType: (state, paymentType) => {
    state.quotePaymentType = paymentType
  },

  setQuotePricesAndDiscounts: (state, pricesAndDiscounts) => {
    state.quotePricesAndDiscounts = pricesAndDiscounts
  },

  setIsQuotePaymentLoading: (state, status) => {
    state.isQuotePaymentLoading = status
  },

  setQuoteWasNotFound: (state, status) => {
    state.quoteWasNotFound = status
  },

  setQuotePaymentStatus: (state, paymentResult) => {
    state.quotePaymentStatus = paymentResult
  },

  setShowQuoteMessageSuccess: (state, status) => {
    state.showQuoteMessageSuccess = status
  },

  setIsQuotePaid: (state, status) => {
    state.isQuotePaid = status
  },

  setIsQuoteClear: (state, status) => {
    state.isQuoteClear = status
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
